import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { RevisionModel } from '../../../../api/api.types';
import { useTranslation } from 'react-i18next';
import { PricingApi } from '../../../../api/api.apiclient';
import AuditLog from '../../../../components/tables/AuditLog';
import { LoaderBar } from '../../../../components/forms/LoaderBar';


const OneWayFeeAuditLog: React.FC<RouteComponentProps> =
  (props) => {

    const [ revisions, setRevisions ] = useState<RevisionModel[]>([]);
    const [ pickupDeskCode, setPickupDeskCode ] = useState<string | null>();
    const [ returnDeskCode, setReturnDeskCode ] = useState<string | null>();
    const [ isLoading, setIsLoading ] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
      const pickupDesk = new URLSearchParams(props.location.search).get('pickup');
      const returnDesk = new URLSearchParams(props.location.search).get('return');


      if (!pickupDesk || !returnDesk) return;
      console.error(
        'OneWayFeeAuditLog: ',
        pickupDesk,
        returnDesk
      );
      setPickupDeskCode(pickupDesk);
      setReturnDeskCode(returnDesk);
      PricingApi.OneWayFees.getOneWayFeeRevisions(pickupDesk, returnDesk)
        .then((resp) => {
          setRevisions(resp.data);
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }, [ t, props.location.search, pickupDeskCode, returnDeskCode ]);

    return (
      <div className="page-content">
        <div className="row justify-content-end pb-2">
          <div className="col-12">
            <h1 className="mb-0">One way fee {pickupDeskCode} - {returnDeskCode} audit log</h1>
          </div>
        </div>
        {isLoading && <LoaderBar/>}
        <AuditLog
          revisions={revisions}
        />
      </div>
    );
  };
export default OneWayFeeAuditLog;